///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GtthNotificationsService } from './notifications.service';
import { GtthNotificationModel } from './notifications.model';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'winde-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [MatProgressBarModule, CommonModule]
})
export class GtthNotificationsComponent implements OnInit, OnDestroy {
    public notifications: GtthNotificationModel[] = [];
    private notificationsSubscription: Subscription;

    constructor(
        private readonly notificationsService: GtthNotificationsService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.notificationsSubscription = this.notificationsService
            .getNotifications()
            .subscribe((notifications: GtthNotificationModel[]) => (this.notifications = notifications));
    }

    openProject(projectid): void {
        this.router.navigate(['./project-view', projectid]);
    }

    ngOnDestroy(): void {
        if (this.notificationsSubscription) {
            this.notificationsSubscription.unsubscribe();
            this.notificationsSubscription = undefined;
        }
    }
}
